module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAABCAYAAACVOl3IAAAAEElEQVQYV2P8////f4ZhCABYhQP+1NMoQQAAAABJRU5ErkJggg=="